// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Client = require("../../clients/types/Client.bs.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Property = require("../../clients/types/Property.bs.js");
var BuyerNeed = require("../../clients/types/BuyerNeed/BuyerNeed.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Types__User = require("../../user/Types__User.bs.js");
var GraphQLHelpers = require("../../common/GraphQL/GraphQLHelpers.bs.js");
var GraphQLConverter = require("../../common/GraphQLConverter.bs.js");

function decode(obj) {
  var partial_arg = GraphQLConverter.Helpers.someOk(obj.client, "client was None");
  var partial_arg$1 = GraphQLConverter.Helpers.ok(obj.status);
  var partial_arg$2 = GraphQLConverter.Helpers.ok(obj.price);
  var partial_arg$3 = GraphQLConverter.Helpers.ok(obj.location);
  var partial_arg$4 = GraphQLConverter.Helpers.ok(obj.address);
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$3, param);
  };
  var partial_arg$7 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg$2, param);
  };
  var partial_arg$8 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$7, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (address, $$location, price, status, client) {
                return {
                        address: address,
                        location: $$location,
                        price: price,
                        status: status,
                        anonymousMatching: obj.anonymousMatching,
                        client: client
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$8, partial_arg, param);
            });
}

var ppx_printed_query = "fragment UsersMatch__Property on Property   {\nid  \n..." + Property.Address.Address.name + "   \n..." + Property.DisplayLocation.PropertyDisplayLocation.name + "   \n..." + Property.Price.Price.name + "   \n..." + Property.Status.PropertyStatus.name + "   \nanonymousMatching  \nclient  {\n..." + Client.Fragment.DecodedClient.name + "   \n}\n\n}\n" + Client.Fragment.DecodedClient.query + Property.Address.Address.query + Property.DisplayLocation.PropertyDisplayLocation.query + Property.Price.Price.query + Property.Status.PropertyStatus.query;

function parse(value) {
  var value$1 = Js_json.decodeObject(value);
  var tmp;
  if (value$1 !== undefined) {
    var value$2 = Caml_option.valFromOption(value$1);
    var value$3 = Js_dict.get(value$2, "id");
    var field_id = value$3 !== undefined ? Caml_option.valFromOption(value$3) : Js_exn.raiseError("Unexpected GraphQL query response");
    var value$4 = Js_dict.get(value$2, "anonymousMatching");
    var field_anonymousMatching;
    if (value$4 !== undefined) {
      var value$5 = Caml_option.valFromOption(value$4);
      field_anonymousMatching = GraphQLHelpers.defaultToFalse(!(value$5 == null) ? value$5 : undefined);
    } else {
      field_anonymousMatching = Js_exn.raiseError("Unexpected GraphQL query response");
    }
    var value$6 = Js_dict.get(value$2, "client");
    var field_client;
    if (value$6 !== undefined) {
      var value$7 = Caml_option.valFromOption(value$6);
      field_client = (value$7 == null) ? undefined : Curry._1(Client.Fragment.DecodedClient.parse, value$7);
    } else {
      field_client = undefined;
    }
    tmp = {
      id: field_id,
      address: Curry._1(Property.Address.Address.parse, value$2),
      location: Curry._1(Property.DisplayLocation.PropertyDisplayLocation.parse, value$2),
      price: Curry._1(Property.Price.Price.parse, value$2),
      status: Curry._1(Property.Status.PropertyStatus.parse, value$2),
      anonymousMatching: field_anonymousMatching,
      client: field_client
    };
  } else {
    tmp = Js_exn.raiseError("Unexpected GraphQL query response");
  }
  return decode(tmp);
}

var name = "UsersMatch__Property";

function ret_type(f) {
  return {};
}

var MT_Ret = {};

var UsersMatch__Property = {
  ppx_printed_query: ppx_printed_query,
  query: ppx_printed_query,
  parse: parse,
  name: name,
  ret_type: ret_type,
  MT_Ret: MT_Ret
};

var Property$1 = {
  decode: decode,
  UsersMatch__Property: UsersMatch__Property,
  Fragment: undefined
};

function decode__UsersMatch__Property(obj) {
  var partial_arg = GraphQLConverter.Helpers.someOk(obj.source, "source was None");
  return GraphQLConverter.Helpers.run(function (source) {
                return {
                        id: obj.id,
                        dismissed: obj.dismissed,
                        property: source
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap((function (param) {
                            return GraphQLConverter.Helpers.source(obj, param);
                          }), partial_arg, param);
            });
}

var ppx_printed_query$1 = "fragment UsersMatch__MatchForProperty on MatchForProperty   {\nid  \ndismissed  \nsource  {\n...UsersMatch__Property   \n}\n\n}\n" + ppx_printed_query;

function parse$1(value) {
  var value$1 = value["dismissed"];
  var value$2 = value["source"];
  return decode__UsersMatch__Property({
              id: value["id"],
              dismissed: GraphQLHelpers.defaultToFalse(!(value$1 == null) ? value$1 : undefined),
              source: !(value$2 == null) ? parse(value$2) : undefined
            });
}

var name$1 = "UsersMatch__MatchForProperty";

function ret_type$1(f) {
  return {};
}

var MT_Ret$1 = {};

var UsersMatch__MatchForProperty = {
  ppx_printed_query: ppx_printed_query$1,
  query: ppx_printed_query$1,
  parse: parse$1,
  name: name$1,
  ret_type: ret_type$1,
  MT_Ret: MT_Ret$1
};

var UsersMatches = {
  Property: Property$1,
  decode__UsersMatch__Property: decode__UsersMatch__Property,
  UsersMatch__MatchForProperty: UsersMatch__MatchForProperty,
  Fragment: undefined
};

function decode__usersPropertyMatches(param) {
  return GraphQLConverter.Helpers.decodeRequired("usersPropertyMatches was None", (function (param) {
                return GraphQLConverter.Helpers.decodeArray((function (param) {
                              return GraphQLConverter.Helpers.decodeRequired("match was None", (function (i) {
                                            return i;
                                          }), param);
                            }), param);
              }), param);
}

function decode__BuyerNeedContext(obj) {
  var partial_arg = GraphQLConverter.Helpers.ok(GraphQLConverter.Helpers.decodeOption((function (i) {
              return i;
            }), obj.client));
  var partial_arg$1 = GraphQLConverter.Helpers.ok(obj.usersPropertyMatches);
  var partial_arg$2 = GraphQLConverter.Helpers.someOk(obj.agent, "agent was None");
  var partial_arg$3 = GraphQLConverter.Helpers.ok(obj.buyerNeed);
  var partial_arg$4 = function (param) {
    return GraphQLConverter.Helpers.flatMap((function (param) {
                  return GraphQLConverter.Helpers.source(obj, param);
                }), partial_arg$3, param);
  };
  var partial_arg$5 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$4, partial_arg$2, param);
  };
  var partial_arg$6 = function (param) {
    return GraphQLConverter.Helpers.flatMap(partial_arg$5, partial_arg$1, param);
  };
  return GraphQLConverter.Helpers.run(function (buyerNeed, agent, usersMatches, client) {
                return {
                        buyerNeed: buyerNeed,
                        agent: agent,
                        usersMatches: usersMatches,
                        client: client
                      };
              })(function (param) {
              return GraphQLConverter.Helpers.flatMap(partial_arg$6, partial_arg, param);
            });
}

var ppx_printed_query$2 = "fragment BuyerNeedContext__BuyerNeed on BuyerNeed   {\n..." + BuyerNeed.Basic.BasicBuyerNeed.name + "   \nagent  {\n..." + Types__User.Fragment.User.name + "   \n}\n\nusersPropertyMatches  {\n..." + name$1 + "   \n}\n\nclient  {\n..." + Client.Fragment.DecodedClient.name + "   \n}\n\n}\n" + BuyerNeed.Basic.BasicBuyerNeed.query + Client.Fragment.DecodedClient.query + Types__User.Fragment.User.query + ppx_printed_query$1;

function parse$2(value) {
  var value$1 = value["agent"];
  var value$2 = value["usersPropertyMatches"];
  var value$3 = value["client"];
  return decode__BuyerNeedContext({
              buyerNeed: Curry._1(BuyerNeed.Basic.BasicBuyerNeed.parse, value),
              agent: !(value$1 == null) ? Curry._1(Types__User.Fragment.User.parse, value$1) : undefined,
              usersPropertyMatches: decode__usersPropertyMatches(!(value$2 == null) ? Js_array.map((function (value) {
                            if (!(value == null)) {
                              return parse$1(value);
                            }
                            
                          }), value$2) : undefined),
              client: !(value$3 == null) ? Curry._1(Client.Fragment.DecodedClient.parse, value$3) : undefined
            });
}

function ret_type$2(f) {
  return {};
}

var MT_Ret$2 = {};

var BuyerNeedContext__BuyerNeed = {
  ppx_printed_query: ppx_printed_query$2,
  query: ppx_printed_query$2,
  parse: parse$2,
  name: "BuyerNeedContext__BuyerNeed",
  ret_type: ret_type$2,
  MT_Ret: MT_Ret$2
};

var BuyerNeedContext = {
  UsersMatches: UsersMatches,
  decode__usersPropertyMatches: decode__usersPropertyMatches,
  decode__BuyerNeedContext: decode__BuyerNeedContext,
  BuyerNeedContext__BuyerNeed: BuyerNeedContext__BuyerNeed,
  Fragment: undefined
};

var ppx_printed_query$3 = "fragment BuyerNeedContextSummaryContextSummary__BuyerNeed on BuyerNeed   {\n..." + BuyerNeed.Basic.BasicBuyerNeed.name + "   \n}\n" + BuyerNeed.Basic.BasicBuyerNeed.query;

function parse$3(value) {
  return Curry._1(BuyerNeed.Basic.BasicBuyerNeed.parse, value);
}

function ret_type$3(f) {
  return {};
}

var MT_Ret$3 = {};

var BuyerNeedContextSummaryContextSummary__BuyerNeed = {
  ppx_printed_query: ppx_printed_query$3,
  query: ppx_printed_query$3,
  parse: parse$3,
  name: "BuyerNeedContextSummaryContextSummary__BuyerNeed",
  ret_type: ret_type$3,
  MT_Ret: MT_Ret$3
};

var BuyerNeedContextSummary = {
  BuyerNeedContextSummaryContextSummary__BuyerNeed: BuyerNeedContextSummaryContextSummary__BuyerNeed,
  Fragment: undefined
};

exports.BuyerNeedContext = BuyerNeedContext;
exports.BuyerNeedContextSummary = BuyerNeedContextSummary;
/* Client Not a pure module */
